export const audioTimeToMMSS = (audioTime: number): string => {
  const minutes = `${Math.floor(audioTime / 60)}`
  const seconds = `${Math.floor(audioTime - +minutes * 60)}`
  return minutes.padStart(2, '0') + ':' + seconds.padStart(2, '0')
}

export const currentPercentage = (trackProgress: number, duration: number): string =>
  duration ? `${(trackProgress / duration) * 100}%` : '0%'
